<nz-layout class="layout ie11up">
  <nz-drawer
    nzClosable="false"
    [nzVisible]="isMobileMenuVisible"
    nzPlacement="left"
    nzTitle=""
    (nzOnClose)="closeMobileMenu()"
    nzWrapClassName="mobile-menu"
  >
    <ng-container *nzDrawerContent>
      <app-sidebar (onSiderClick)="isMobileMenuVisible = false"></app-sidebar>
    </ng-container>
  </nz-drawer>
  <nz-layout>
    <nz-header>
      <div class="main-header" >
        <app-header></app-header>
        <nz-alert class="status-message" *ngIf="statusMessage != null" [nzType]="statusMessage.type" [nzMessage]="statusMessage.messageHtml" [nzShowIcon]="false" 
          [nzBanner]="false" [nzCloseable]="true" (nzOnClose)="onStatusMessageClose()"></nz-alert>
        <div style="background-color:white;height: 1px;"></div>
        <app-menu *ngIf="isDesktop && !hideMainMenu"></app-menu>
      </div>
      <i class="trigger" nzType="menu" nz-icon *ngIf="isMobile && !hideMainMenu" (click)="openMobileMenu()"></i>
    </nz-header>
    <nz-content>
      <div class="wrapper main-content">
        <app-body></app-body>
      </div>
    </nz-content>
    <nz-footer>
      <div class="main-footer">
        <app-footer *ngIf="!hideFooter"></app-footer>
      </div>
    </nz-footer>
  </nz-layout>
</nz-layout>
